module.exports = __webpack_public_path__ + "img/copy-outline.a0e3aba3.svg";